import { FeatureEntitlementName } from '@jupiterone/entitlement-types';
import { useEntitlements } from '@jupiterone/jupiter-web-toolkit';

interface FeatureEntitlementCheckerProps {
  featureEntitlementName: FeatureEntitlementName;
  children: JSX.Element;
}

export default function FeatureEntitlementChecker({
  children,
  featureEntitlementName,
}: FeatureEntitlementCheckerProps) {
  const entitlementData = useEntitlements();
  const { entitlementEnforceAll } = entitlementData;

  const canAccess: boolean = entitlementEnforceAll([featureEntitlementName]);

  if (!canAccess) {
    return null;
  }

  return children;
}
